import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const GET_LEGAL_ENTITIES_REQUEST = 'GET_LEGAL_ENTITIES_REQUEST';
export const GET_LEGAL_ENTITIES_SUCCESS = 'GET_LEGAL_ENTITIES_SUCCESS';
export const GET_LEGAL_ENTITIES_FAILURE = 'GET_LEGAL_ENTITIES_FAILURE';

function requestGetLegalEntities() {
  return {
    type: GET_LEGAL_ENTITIES_REQUEST,
    isGettingLegalEntities: true
  };
}

function receiveGetLegalEntities(legalEntities, legalEntitiesCount) {
  return {
    type: GET_LEGAL_ENTITIES_SUCCESS,
    isGettingLegalEntities: false,
    legalEntities,
    legalEntitiesCount
  };
}

function rejectGetLegalEntities() {
  return {
    type: GET_LEGAL_ENTITIES_FAILURE,
    isGettingLegalEntities: false
  };
}

export function getLegalEntities(pageNumber, pageSize, totalLimit, sortByField, sortDirection, filterList, searchQuery, legalEntity, legalEntitySelected, accountNumber, accountNumberSelected, customer, customerSelected) {
  return (dispatch) => {
    dispatch(requestGetLegalEntities());
    const promise = () => ApiService
      .getLegalEntities(pageNumber, pageSize, totalLimit, sortByField, sortDirection, filterList, searchQuery, legalEntity, legalEntitySelected, accountNumber, accountNumberSelected, customer, customerSelected)
      .then((response) => {
        dispatch(receiveGetLegalEntities(response.data.items, response.data.totalCount));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectGetLegalEntities, true));
        }
      });

    return promise();
  };
}

export function getLegalEntitiesByObject(requestObject) {
  return getLegalEntities(
    requestObject.pageNumber,
    requestObject.pageSize,
    requestObject.totalLimit,
    requestObject.sortByField,
    requestObject.sortDirection,
    requestObject.filterList,
    requestObject.searchQuery,
    requestObject.legalEntity,
    requestObject.legalEntitySelected,
    requestObject.accountNumber,
    requestObject.accountNumberSelected,
    requestObject.customer,
    requestObject.customerSelected
  );
}
